<script>
import { onMount } from "svelte";
import { fade } from "svelte/transition";
import {link} from 'svelte-spa-router'
import Loading from "../components/donorflow-ui/Loading.svelte";
let db;
let quizes = [];
let loading = true;

function getQuizes(){
    db.collection('quizes')
        .where('sportal', "==", 3)
        .get()
        .then(docs => {
            docs.forEach(doc => {
                quizes = [...quizes, {id: doc.id, ...doc.data()}]
                loading = false;
            });
        })
        .catch(e => {
            console.log(e);
        });
}

onMount(() => {
    db = firebase.firestore();
    getQuizes();
})

</script>
<div style="background: #FFF08E; height: 360px;" />
<div style="margin-top: -300px;" in:fade>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="card" style="min-height: 400px;">
                    <div class="card-body">
                        {#if loading}
                        <div class="text-center">
                            <Loading text="Fetching quizes..." />
                        </div>
                        {:else}
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Responses</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {#each quizes as q}
                                    <tr>
                                        <td><a href={`/quiz/${q.id}`} use:link>{q.name}</a></td>
                                        <td>X</td>
                                    </tr>
                                    {/each}
                                </tbody>
                            </table>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<a href="#/new">New</a>